module.exports = __webpack_public_path__ + "static/img/task-img1.e737f1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newYearActivity/task-img1.png
// module id = AJTi
// module chunks = 2